<template>
  <div class="content content-full">
    <div class="page-inner">
      <div class="page-header">
        <h2 class="page-title fw-thin text-35">Presave</h2>
      </div>

      <div class="card mt-4">
        <div class="card-body p-0 pos-relative table-card">
          <div class="table-responsive">
            <table class="table mb-0">
              <thead>
                <th>{{ $t('campaign') }}</th>
                <th>{{ $t('artist') }}</th>
                <th>UPC</th>
                <th>SmartLink</th>
                <th>{{ $t('release_date') }}</th>
                <th>{{ $t('subscribers') }}</th>
                <th width="180"></th>
              </thead>
              <tbody>
                <tr v-if="!loading && !campaigns.length">
                  <td colspan="7">
                    {{ $t('campaign_created_automatically') }}
                  </td>
                </tr>
                <tr v-for="campaign in campaigns" v-bind:key="campaign._id">
                  <td>
                    <router-link :to="`/presave-campaigns/${campaign._id}`" tag="a">
                      {{ campaign.name }}
                    </router-link>
                  </td>
                  <td>
                    {{ campaign.artist.name }}
                  </td>
                  <td>
                    {{ campaign.upc }}
                  </td>
                  <td class="text-center">
                    <a :href="`https://indiefy.net/release/${campaign.distribution.key}`" class="btn btn-white btn-sm" target="_blank">
                      <i class="fa fa-external-link-alt"></i>
                    </a>
                  </td>
                  <td>
                    {{ campaign.release_date }}
                  </td>
                  <td>
                    {{ campaign.subscribers || 0 }}
                  </td>
                  <td class="text-right">
                    <a :href="`/release/${campaign.distribution.key}`" target="_blank" class="btn-default btn btn-sm">
                      {{ $t('view') }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <UpgradeOverlay v-if="!user.subscription && user.published" :title="$t('presave_campaigns')" :text="$t('presave_campaigns_text')"></UpgradeOverlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Presave from '../services/presave'
import UpgradeOverlay from './UpgradeOverlay'
import moment from 'moment'

export default {
  data () {
    return {
      user: {},
      loading: true,
      campaigns: []
    }
  },
  methods: {
    getCampaigns: function () {
      Presave.getAll().then(response => {
        this.campaigns = response.data || []
        this.loading = false

        this.campaigns.forEach(item => {
          item.release_date = moment.utc(item.release_date).format('LL')

          if (item.spotify_artist) {
            item.spotify_artist_text = item.spotify_artist.split('/').pop().split('?')[0]
          }
        })
      })
    }
  },
  created: function () {
    this.user = this.$user

    if (this.user.subscription) {
      this.getCampaigns()
    } else {
      this.loading = false
      this.$router.push('/upgrade?from=presave')
    }
  },
  components: {
    UpgradeOverlay
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table-card {
  min-height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/PresaveCampaigns.vue